var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingTrialLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 10.106H20C20.2652 10.106 20.5196 10.2114 20.7071 10.3989C20.8946 10.5865 21 10.8408 21 11.106V21.106C21 21.3713 20.8946 21.6256 20.7071 21.8132C20.5196 22.0007 20.2652 22.106 20 22.106H4C3.73478 22.106 3.48043 22.0007 3.29289 21.8132C3.10536 21.6256 3 21.3713 3 21.106V11.106C3 10.8408 3.10536 10.5865 3.29289 10.3989C3.48043 10.2114 3.73478 10.106 4 10.106H5V9.10605C4.99943 7.52875 5.53158 5.99749 6.51019 4.76048C7.4888 3.52347 8.8565 2.65323 10.3916 2.29081C11.9267 1.92839 13.5392 2.09505 14.9677 2.76376C16.3963 3.43247 17.5571 4.56404 18.262 5.97505L16.473 6.86905C15.9695 5.86106 15.1403 5.05269 14.1198 4.57499C13.0994 4.09729 11.9475 3.97827 10.8509 4.23722C9.7543 4.49618 8.77733 5.11792 8.07836 6.00166C7.37939 6.88539 6.9994 7.97931 7 9.10605V10.106ZM5 12.106V20.106H19V12.106H5ZM10 15.106H14V17.106H10V15.106Z",
    fill: "#1A22E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingTrialLock);
export default __webpack_public_path__ + "static/media/onboarding-trial-lock.bd670b5c06dba562df9b914a8030df08.svg";
export { ForwardRef as ReactComponent };